export const container = ({ isMoving, transitionDuration, isActive }) => ({
    width: '100%',
    transform: isMoving ? 'translateX(20px)' : 'translateX(0px)',
    opacity: isMoving || !isActive ? '0' : '1',
    willChange: 'transform, opacity',
    transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform ${transitionDuration}s, cubic-bezier(0.4, 0.0, 0.2, 1) opacity ${transitionDuration}s`,

    tablet: {
        width: '45.15152%',
    },
});

export const image = () => ({
    maxHeight: '100%',
});
